<template>
    <!-- 果园堆肥点（perish_v1.2）：只收变质食物，批量转化为肥料 -->
    <el-dialog customClass="wrap" title="堆肥点" :visible.sync="compostTableVisible" :before-close="compost_dialog_close" :modal-append-to-body="false">
        <div class="compostbg" v-loading="loading">
            <div class="composttitle">
                果园堆肥点
            </div>
            <div class="compostdesc">
                变质的食物别扔！交给堆肥点化作肥料：每 <b>5</b> 个变质物转化 <b>1</b> 个【肥料】，不同变质物可合并凑数（余数随肥力流失）。<br>
                【肥料】在果园<b>种植收获时自动消耗 1 个</b>，本次收获 +1 件（种植结果会标注【丰收】）。背包现有肥料：<b>{{ fertilizerCount }}</b> 个。
            </div>

            <div class="compostcontrol" v-if="spoiledItems.length > 0">
                <input type="checkbox" id="compostCheckAll" :checked="allChecked" @change="checkAll"/>
                <label for="compostCheckAll">全选</label>
                <span class="compost-tip" v-if="willGetFertilizer > 0">本次可转化 <b>{{ willGetFertilizer }}</b> 个肥料</span>
                <span class="compost-tip" v-else>选中项总量凑满 5 个才能转化（可跨道具合并）</span>
                <el-button type="success" plain size="mini" :disabled="checkCompostItemData.length === 0" @click="compostBatch();">开始堆肥</el-button>
            </div>

            <div class="compostlist" v-if="spoiledItems.length > 0">
                <div v-for="item in spoiledItems" v-bind:key="item.itemId" class="itemdiv">
                    <input type="checkbox" :id="'compost' + item.itemId" :value="item.itemId" v-model="checkCompostItemData"/>
                    <label :for="'compost' + item.itemId">
                        <FantasyItemCard :item="item"></FantasyItemCard>
                    </label>
                </div>
                <div style="clear:both"></div>
            </div>
            <div class="noSpoiled" v-else>
                背包里没有变质的食物<br>
                <span class="noSpoiled-tip">生鲜食物保质期 3 天、熟食 7 天，过期变质后就会出现在这里</span>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {getRequest, postJson, onResult} from '../../utils/api'
import Message from 'element-ui/lib/message'
import FantasyItemCard from '../common/FantasyItemCard'

const FERTILIZER_ITEM_TYPE = '139'
const COMPOST_RATIO = 5

export default {
  name: 'compostPanel',
  components: { FantasyItemCard },
  props:{
    compostVisible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
        pocketItems: [],
        checkCompostItemData: [], // 勾选的变质道具 itemId
        loading: false,
    };
  },
  computed: {
    compostTableVisible() {
      return this.compostVisible;
    },
    // 只显示已变质的食物（state 由后端保鲜服务统一下发）
    spoiledItems() {
      return (this.pocketItems || []).filter(it => it.state === 'spoiled');
    },
    fertilizerCount() {
      return (this.pocketItems || [])
        .filter(it => it.itemType == FERTILIZER_ITEM_TYPE)
        .reduce((sum, it) => sum + (it.stackCount || 0), 0);
    },
    // 全选框状态（由数据派生）
    allChecked() {
      return this.spoiledItems.length > 0
        && this.checkCompostItemData.length === this.spoiledItems.length;
    },
    // 本次勾选可转化的肥料数（不同变质物合并凑数，总量 5:1）
    willGetFertilizer() {
      const total = (this.pocketItems || [])
        .filter(it => this.checkCompostItemData.indexOf(it.itemId) > -1)
        .reduce((sum, it) => sum + (it.stackCount || 0), 0);
      return Math.floor(total / COMPOST_RATIO);
    }
  },
  watch: {
    compostVisible: {
      // immediate：组件在 showCompostDiv v-if 内，打开时随 prop=true 首次挂载，
      // 不加 immediate 则 watcher 不会触发，面板打开永远拉不到背包数据
      immediate: true,
      handler(newVal) {
        if (newVal === true) {
          this.loadPocket();
        }
      }
    }
  },
  methods: {
    compost_dialog_close(){
      this.$emit("compost_dialog_close");
    },
    // 拉取背包：保鲜服务已为每项补 state/expireAt
    loadPocket() {
      const _this = this;
      this.loading = true;
      getRequest('/item/cabinet/openPocket', {}).then(resp=> {
        _this.loading = false;
        if (resp.status == 200) {
          const respData = resp.data;
          if (200 == respData.status) {
            _this.pocketItems = respData.data.pocketItems || [];
            // 默认全选变质物：不同变质物可合并凑数，任一栈都参与总量计算
            _this.checkCompostItemData = _this.spoiledItems.map(it => it.itemId);
          } else {
            Message.error(respData.message);
          }
        } else {
          Message.error('用户非法⊙﹏⊙∥!');
        }
      }, ()=> {
        _this.loading = false;
        Message.error('用户非法⊙﹏⊙∥!');
      });
    },
    checkAll(e){
      if(e.target.checked){
        this.checkCompostItemData = this.spoiledItems.map(it => it.itemId);
      }else {
        this.checkCompostItemData = [];
      }
    },
    // 批量堆肥：逐栈 5:1 转化，失败栈跳过并在结果中说明
    compostBatch(){
      let _this = this;
      if (this.checkCompostItemData.length === 0) {
        Message.error('请先勾选要堆肥的变质道具');
        return;
      }
      this.$confirm('确定把选中的变质物堆成肥料吗？每 5 个变质物转化 1 个【肥料】。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(function () {
          postJson('/item/item/compostBatch', _this.checkCompostItemData).then(resp=> {
              onResult(resp, {
                  success: data => {
                      if (data.message) Message.success(data.message);
                      _this.loadPocket();
                      _this.$store.dispatch('user/fetchUserDetail');
                      _this.$root.eventHub.$emit('refreshCabinets');
                  }
              });
          });
      }, function () {})
    },
  }
}
</script>

<style scoped>
.compostbg {
    width:100%;
    min-height: 300px;
}
.composttitle {
    padding:3px 5px;
    background-color:#72b653;
    font-size:16px;
    font-weight:bold;
    color:#fff;
    letter-spacing:5px;
    text-align:center;
}
.compostdesc {
    margin:8px 5px;
    padding:8px 10px;
    background:#f4f9ec;
    border:1px solid #cfe3b8;
    border-radius:4px;
    font-size:12px;
    line-height:1.8;
    color:#5a6b45;
}
.compostcontrol {
    margin:5px;
    line-height: 32px;
    text-align: left;
}
.compostcontrol input,label {
    vertical-align:middle;
}
.compost-tip {
    margin-left: 12px;
    font-size: 12px;
    color: #888;
}
.compostlist {
    padding:5px;
    text-align:center;
}
.itemdiv {
    height:110px;
    width:70px;
    float:left;
    position:relative;
    margin:5px;
}
.itemdiv input {
    position:absolute;
    top:0;
    left:0;
}
.noSpoiled {
    padding:20px 5px;
    font-size:15px;
    font-weight:bold;
    letter-spacing:3px;
    text-align:center;
    color:#8a9a6d;
}
.noSpoiled-tip {
    display:block;
    margin-top:8px;
    font-size:12px;
    font-weight:normal;
    letter-spacing:0;
    color:#aaa;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
    .compostbg {
        max-height: 60vh;
        overflow-y: auto;
    }
    .itemdiv {
        width: 60px;
        height: 100px;
        margin: 3px;
    }
}
</style>
